import { render } from "./PerPanel.vue?vue&type=template&id=64c6d708"
import script from "./PerPanel.vue?vue&type=script&lang=js"
export * from "./PerPanel.vue?vue&type=script&lang=js"

import "./PerPanel.vue?vue&type=style&index=0&id=64c6d708&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__